(() => {
 const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
 if (!customElements.get('tc-carousel')) customElements.define('tc-carousel', class extends HTMLElement {
  connectedCallback() {
   this.track = this.querySelector('[data-track]'); if (!this.track) return;
   this.abort = new AbortController(); const options = { signal: this.abort.signal };
   this.querySelector('[data-prev]')?.addEventListener('click', () => this.move(-1), options);
   this.querySelector('[data-next]')?.addEventListener('click', () => this.move(1), options);
   this.track.addEventListener('scroll', () => this.update(), options);
   this.resize = new ResizeObserver(() => this.update()); this.resize.observe(this.track); this.update();
  }
  move(direction) {
   const item = this.track.firstElementChild;
   const step = this.hasAttribute('data-single') ? this.track.clientWidth : (item?.getBoundingClientRect().width || 200) + parseFloat(getComputedStyle(this.track).gap || 0);
   this.track.scrollBy({ left: direction * step, behavior: reduced() ? 'instant' : 'smooth' });
  }
  update() {
   const max = this.track.scrollWidth - this.track.clientWidth;
   const prev = this.querySelector('[data-prev]'), next = this.querySelector('[data-next]');
   if (prev) prev.disabled = this.track.scrollLeft <= 2; if (next) next.disabled = this.track.scrollLeft >= max - 2;
   if (this.hasAttribute('data-single')) { const active = Math.round(this.track.scrollLeft / this.track.clientWidth); Array.from(this.track.children).forEach((slide, i) => { slide.inert = i !== active; }); const count = this.querySelector('[data-slide-count]'); if (count) count.textContent = `${active + 1} / ${this.track.children.length}`; }
  }
  disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
 });
 if (!customElements.get('tc-dialog')) customElements.define('tc-dialog', class extends HTMLElement {
  connectedCallback() {
   const dialog = this.querySelector('dialog'); if (!dialog) return;
   this.abort = new AbortController(); const options = { signal: this.abort.signal };
   this.querySelector('[data-dialog-open]')?.addEventListener('click', () => dialog.showModal(), options);
   this.querySelector('[data-dialog-close]')?.addEventListener('click', () => dialog.close(), options);
   dialog.addEventListener('click', (event) => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } }, options);
  }
  disconnectedCallback() { this.abort?.abort(); }
 });
 if (!customElements.get('tc-sticky-atc')) customElements.define('tc-sticky-atc', class extends HTMLElement {
  connectedCallback() {
   this.source = document.getElementById(`ProductInfo-${this.dataset.productSection}`); this.submit = this.source?.querySelector('button[name="add"]'); if (!this.submit) return;
   this.abort = new AbortController();
   this.querySelector('[data-sticky-submit]').addEventListener('click', () => { const current = this.source.querySelector('button[name="add"]'); if (current && !current.disabled) current.click(); }, { signal: this.abort.signal });
   this.intersection = new IntersectionObserver(entries => {
    const shouldHide = entries[0].isIntersecting || entries[0].boundingClientRect.bottom > 0;
    this.hidden = shouldHide;
    document.body.classList.toggle('tc-sticky-atc-visible', !shouldHide);
   }, { threshold: 0 }); this.intersection.observe(this.submit);
   this.mutation = new MutationObserver(() => this.sync()); this.mutation.observe(this.source, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] }); this.sync();
  }
  sync() {
   const button = this.source.querySelector('button[name="add"]'), target = this.querySelector('[data-sticky-submit]'); target.disabled = !button || button.disabled;
   const sourceLabel = button?.querySelector('span:not(.loading__spinner)')?.textContent?.trim() || button?.textContent?.trim();
   this.querySelector('[data-sticky-label]').textContent = sourceLabel || this.dataset.addLabel || 'Add to cart';
   const price = this.source.querySelector('[id^="price-"]'), targetPrice = this.querySelector('[data-sticky-price]');
   if (price && targetPrice) {
    const current = price.querySelector('.price--on-sale .price-item--sale') || price.querySelector('.price__regular .price-item--regular') || price.querySelector('.price-item');
    if (current) targetPrice.textContent = current.textContent.trim();
   }
   this.querySelector('[data-sticky-variant]').textContent = Array.from(this.source.querySelectorAll('variant-selects [data-selected-value]')).map(e => e.textContent.trim()).join(' / ');
  }
  disconnectedCallback() { this.abort?.abort(); this.intersection?.disconnect(); this.mutation?.disconnect(); document.body.classList.remove('tc-sticky-atc-visible'); }
 });
 if (!customElements.get('tc-pdp-purchase')) customElements.define('tc-pdp-purchase', class extends HTMLElement {
  connectedCallback() {
   this.priceSource = document.getElementById(`price-${this.dataset.sectionId}`);
   this.priceTarget = this.querySelector('[data-tc-atc-price]');
   if (!this.priceSource || !this.priceTarget) return;
   this.priceObserver = new MutationObserver(() => this.syncPrice());
   this.priceObserver.observe(this.priceSource, { subtree: true, childList: true, characterData: true });
   this.syncPrice();
  }
  syncPrice() {
   const current = this.priceSource.querySelector('.price--on-sale .price-item--sale') || this.priceSource.querySelector('.price__regular .price-item--regular') || this.priceSource.querySelector('.price-item');
   if (!current) return;
   this.priceTarget.replaceChildren();
   const newPrice = document.createElement('strong'); newPrice.textContent = current.textContent.trim(); this.priceTarget.append(newPrice);
  }
  disconnectedCallback() { this.priceObserver?.disconnect(); }
 });
 if (!customElements.get('tc-shipping-bar')) customElements.define('tc-shipping-bar', class extends HTMLElement {
  connectedCallback() {
   this.update();
   this.timer = window.setInterval(() => this.update(), 30000);
  }
  isBusinessDay(date) { return date.getDay() !== 0 && date.getDay() !== 6; }
  nextBusinessDay(date) {
   const next = new Date(date);
   do { next.setDate(next.getDate() + 1); } while (!this.isBusinessDay(next));
   return next;
  }
  addBusinessDays(date, days) {
   let result = new Date(date), remaining = Math.max(0, days);
   while (remaining > 0) {
    result.setDate(result.getDate() + 1);
    if (this.isBusinessDay(result)) remaining -= 1;
   }
   return result;
  }
  sameDate(first, second) { return first.getFullYear() === second.getFullYear() && first.getMonth() === second.getMonth() && first.getDate() === second.getDate(); }
  update() {
   const now = new Date();
   const cutoffSetting = Number(this.dataset.cutoffHour);
   const cutoffHour = Number.isFinite(cutoffSetting) ? Math.min(23, Math.max(0, cutoffSetting)) : 15;
   let shipDate = new Date(now);
   shipDate.setHours(cutoffHour, 0, 0, 0);
   if (!this.isBusinessDay(shipDate) || now >= shipDate) {
    shipDate = this.nextBusinessDay(shipDate);
    shipDate.setHours(cutoffHour, 0, 0, 0);
   }

  const tomorrow = new Date(now);
tomorrow.setDate(tomorrow.getDate() + 1);

const shipsToday = this.sameDate(shipDate, now);
const orderPrefix = this.querySelector(
  '.tc-shipping-bar__dispatch span:first-child'
);

let countdown;
let dispatch;

if (shipsToday) {
  const totalMinutes = Math.max(
    1,
    Math.ceil((shipDate - Today) / 60000)
  );
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  countdown =
    hours > 0
      ? `${hours} hr ${minutes} min`
      : `${minutes} min`;

  orderPrefix.textContent =
    this.dataset.orderPrefix || 'Order within';

  dispatch =
    this.dataset.shipsToday || 'ships today.';
} else {
  countdown = 'Today';
  orderPrefix.textContent = 'Order';

  dispatch = this.sameDate(shipDate, tomorrow)
    ? this.dataset.shipsTomorrow || 'ships tomorrow.'
    : `${this.dataset.shipsPrefix || 'ships'} ${shipDate.toLocaleDateString(
        'en-US',
        { weekday: 'long' }
      )}.`;
}

   const minimum = Math.max(1, Number(this.dataset.deliveryMin) || 5);
   const maximum = Math.max(minimum, Number(this.dataset.deliveryMax) || 8);
   const firstDelivery = this.addBusinessDays(shipDate, minimum);
   const lastDelivery = this.addBusinessDays(shipDate, maximum);
   const formatDate = date => date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
   this.querySelector('[data-shipping-countdown]').textContent = countdown;
   this.querySelector('[data-shipping-dispatch]').textContent = dispatch;
   this.querySelector('[data-shipping-delivery]').textContent = `${formatDate(firstDelivery)} – ${formatDate(lastDelivery)}`;
  }
  disconnectedCallback() { window.clearInterval(this.timer); }
 });
 if (!customElements.get('tc-cart-discount')) customElements.define('tc-cart-discount', class extends HTMLElement {
  connectedCallback() {
   this.abort = new AbortController();
   this.querySelector('[data-apply]').addEventListener('click', () => this.apply(), {signal: this.abort.signal});
   this.querySelector('input').addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); this.apply(); } }, {signal: this.abort.signal});
  }
  async apply() {
   const button = this.querySelector('[data-apply]'), input = this.querySelector('input');
   if (button.disabled || !input.value.trim()) return;
   const cart = this.closest('cart-drawer'); if (!cart) return;
   button.disabled = true; this.setAttribute('aria-busy', 'true');
   try {
    const response = await fetch(window.routes.cart_update_url, {...fetchConfig(), body: JSON.stringify({discount: input.value.trim(), sections: cart.getSectionsToRender().map(s => s.id), sections_url: window.location.pathname})});
    const result = await response.json();
    if (!response.ok || result.errors || !result.sections?.['cart-drawer']) throw new Error('Discount update failed');
    cart.renderContents(result);
   } catch { this.querySelector('[data-discount-status]').textContent = this.dataset.error; }
   finally { button.disabled = false; this.removeAttribute('aria-busy'); }
  }
  disconnectedCallback() { this.abort?.abort(); }
 });
})();
